import { animate, keyframes, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, Output, EventEmitter, OnChanges, SimpleChanges, ViewChild } from '@angular/core';
import * as kf from '../../../../core/keyframes';
import { AssetUploadComponent } from '../../../../components/asset-upload/asset-upload.component';
import { SituViewWebApiClient, ThumbnailType, UploadStyleThumbnailRequest, UploadStyleThumbnailResponse } from 'situview-webapi-client';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
  selector: 'style-template-card',
  templateUrl: './style-template-card.component.html',
  styleUrls: ['./style-template-card.component.less'],
  animations: [
    trigger('cardAnimator', [
      transition('* => wobble', animate(1000, keyframes(kf.wobble))),
      transition('* => swing', animate(1000, keyframes(kf.swing))),
      transition('* => jello', animate(1000, keyframes(kf.jello))),
      transition('* => zoomOutRight', animate(1000, keyframes(kf.zoomOutRight))),
      transition('* => slideOutLeft', animate(1000, keyframes(kf.slideOutLeft))),
      transition('* => rotateOutUpRight', animate(1000, keyframes(kf.rotateOutUpRight))),
      transition('* => flipOutY', animate(1000, keyframes(kf.flipOutY))),
      transition('* => headShake', animate(1000, keyframes(kf.headShake)))
    ])
  ]
})
export class StyleTemplateCardComponent implements OnInit, OnChanges {

  @Input() id: string | undefined;
  @Input() companyId: string | undefined;
  @Input() name: string | undefined;
  @Input() category: string | undefined;
  @Input() readonly: boolean = false;
  @Input() thumbnailUrl: string | undefined;
  @Input() searchValue: string = "";
  @Input() selected: boolean = false;
  @Input() animationState: string = '';
  @Input() showCategory: boolean = false;
  @Input() showClear: boolean = false;
  @Input() showSwap: boolean = false;
  @Input() companyName: string = '';
  @Input() companyLogo: string = '';

  thumbnailData: string | undefined;

  @Output() onClear: EventEmitter<string> = new EventEmitter();
  @Output() onSwap: EventEmitter<string> = new EventEmitter();

  constructor(
    private situViewApiClient: SituViewWebApiClient,
    private snackBar: MatSnackBar
  ) { }

  ngOnInit(): void {}

  @ViewChild(AssetUploadComponent) assetUploadComponent: AssetUploadComponent | undefined;

  triggerChildFileUpload(event: MouseEvent) {
    event.stopPropagation();
    if (this.assetUploadComponent) {
      this.assetUploadComponent.triggerFileUpload();
    }
  }

  onAssetLoad(assetBase64: string) {
    if (assetBase64) {
      this.thumbnailData = assetBase64;
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.animationState) {
      this.startAnimation(changes.animationState.currentValue);
    }
  }

  clear() {
    this.onClear.emit(this.id);
  }
  
  swap() {
    this.onSwap.emit(this.id);
  }

  cancelThumbnailUpload() {
    this.thumbnailData = undefined;
  }
  
  saveThumbnailUpload() {
    if (!this.id || !this.thumbnailData) {
      return;
    }

    let request = new UploadStyleThumbnailRequest();
    request.companyId = this.companyId;
    request.id = this.id;
    request.thumbnail = this.thumbnailData.split(',')[1];
    request.thumbnailType = ThumbnailType.Style;

    this.situViewApiClient.uploadStyleThumbnail(request)
      .then((response: UploadStyleThumbnailResponse) => {
        if (response.success) {
          this.thumbnailUrl = response.thumbnailUrl;
          this.thumbnailData = undefined;
          this.snackBar.open(`Thumbnail successfully updated!`, 'OK', { duration: 2000 });
        } else {
          this.snackBar.open(`Could not save thumbnail. Refresh page.`, 'OK', { duration: 2000 });
        }
      })
      .catch(x => {
        this.snackBar.open(`Failed to upload thumbnail`, 'OK', { duration: 2000 });
      });
  }

  startAnimation(state: string) {
    if (!this.animationState) {
      this.animationState = state;
    }
  }

  resetAnimationState() {
    this.animationState = '';
  }
}
